import { useTranslation } from "react-i18next";
import VestelIcon from "../../../atoms/images/VestelIcon";
import Text from "../../content/Text";

const MobileBanner = ({ isShowTitle = false }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`logo-background flex items-center h-[120px] md:hidden ${
        isShowTitle ? " justify-evenly" : " justify-center"
      }`}
    >
      <div>
        <VestelIcon className="w-[171px] h-[171px]" />
      </div>
      {isShowTitle && (
        <Text variant="h2" className="text-white">
          {t("layout.account")}
        </Text>
      )}
    </div>
  );
};

export default MobileBanner;
